"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Email
 * @since 0.1.5
 * @version 0.1.5
 */
exports.email = new RegExp('^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$');
/**
 * Password
 * @since 0.1.5
 * @version 0.1.5
 */
exports.password = new RegExp('^.*(?=.{6,})(?=.*\\d)(?=.*[\\w]).*$');
exports.default = {
    email: exports.email,
    password: exports.password,
};
//# sourceMappingURL=account.js.map